export default "__VITE_ASSET__dac43e82__"